var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.searchRoute ? 'searchRout' : '',attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareValue),expression:"shareValue"}]},[_c('p',{staticClass:"social-share",attrs:{"data-sites":"qzone,qq,weibo,wechat"}})]),_vm._v(" "),(_vm.showHeader)?[_c('v-header')]:_vm._e(),_vm._v(" "),_c('router-view')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80cd397c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 